import dtm from 'scripts/services/dtm';
import appContext from 'scripts/app-context';

export function tryToAddButtonListener(tryCount = 0) {
    const retryTimeout = 500;
    const maxTryCount = 20;
    const chatButton = $('.satisfi_chat-button');

    if (!chatButton[0] && tryCount < maxTryCount) {
        setTimeout(() => tryToAddButtonListener(tryCount + 1), retryTimeout);
        return;
    }

    appContext.model.attr('satisfi-loaded', true);

    chatButton.toggleClass(
        'pill-module-visible',
        appContext.model.attr('pill-module-visible'),
    );

    chatButton.on('click', dtm.trackChatBotButtonClick);
}
